/** matches the locale in local storage and returns the matching text. If the translation is missing, returns the next available text
 * @argument locales: a localization object (e.g.: {it: "esempio", en: "example"})
 */
export const getLocalizedText = (locales) => {
  const lang = localStorage.getItem("B2BLanguage") === "ITA" ? "it" : "en";

  if (typeof locales === "string") return locales;
  if (!locales || !Object?.keys(locales)?.length) return "";
  const availableLocales = Object.keys(locales);
  if (availableLocales.includes(lang) && locales[lang]) {
    return locales[lang];
  }

  for (let locale of availableLocales) {
    if (locales[locale]) {
      return locales[locale];
    }
  }
  return "";
};
